import { render, staticRenderFns } from "./WebhookIcon.vue?vue&type=template&id=28a9dd2a&scoped=true"
import script from "./WebhookIcon.vue?vue&type=script&lang=js"
export * from "./WebhookIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a9dd2a",
  null
  
)

export default component.exports